let openReflectionHandler = null;
let isReflectionOpen = false;
const openStateListeners = new Set();

function notifyOpenStateListeners() {
  openStateListeners.forEach((listener) => listener(isReflectionOpen));
}

export function setContentReflectionHandler(handler) {
  openReflectionHandler = handler;
}

export function getContentReflectionOpenState() {
  return isReflectionOpen;
}

export function subscribeContentReflectionOpenState(listener) {
  openStateListeners.add(listener);
  return () => openStateListeners.delete(listener);
}

export function setContentReflectionOpenState(open) {
  if (isReflectionOpen === open) return;
  isReflectionOpen = open;
  notifyOpenStateListeners();
}

export function triggerContentReflection(payload) {
  if (isReflectionOpen || !openReflectionHandler) return false;
  openReflectionHandler(payload);
  return true;
}
